export default __webpack_public_path__ + "7b3ecbe79a3b7731f76f2c302848cb73.svg";